import { NgModule } from '@angular/core';
import { RRSharedModule } from '../shared-module/shared.module';
import { RRSpinnerModule } from '../spinner/spinner.module';
import { AngularDraggableModule } from 'angular2-draggable';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { RRBootstrapModule } from '../bootstrap/bootstrap.module';
import { RRLightboxComponent } from './components/lightbox/lightbox.component';
//import { AvatarGeneratorComponent } from './components/avatar-generator/avatar-generator.component';
import { FormsModule } from '@angular/forms';
import { RRFormInputsModule } from '../form-inputs/form-inputs.module';
//import { PictofitDressingRoomComponent } from '../pictofit-dressing-room/public-api';

@NgModule({
  declarations: [RRLightboxComponent],
  imports: [
    NgJsonEditorModule,
    AngularDraggableModule,
    RRSharedModule,
    RRBootstrapModule,
    RRSpinnerModule,
    FormsModule,
    RRFormInputsModule,
  ],
  exports: [],
})
export class RRViewersModule {}
